import * as React from 'react'
import { Route, Link, RouteComponentProps } from 'react-router-dom'
import AddFundsModal from '../../../containers/riders/riderdetails/AddFundsModal'
import WalletBalance from '../../../containers/riders/riderdetails/WalletBalance'
import AddCardModal from '../../../containers/riders/riderdetails/AddCardModal'
import { formatPhone } from '../../../utils'
import { IUserTopPanelRider, NotificationPreferenceTypes, IVehicle, IActiveTripResponseV2 } from '../../../types'
import { IAppliedPromotion } from '../../../types/promotions'
import ImageView from '../../ui/ImageView'
import CouponIcon from '../../icons/ui/coupon'
import AppliedPromotion from '../../riders/riderdetails/promotions/AppliedPromotion'
import { BALANCE_TYPES } from '../../../constants/wallet'
import { AnyARecord } from 'dns'
import Edit from '../../icons/ui/Edit'
import ContextMenu from '../../ui/ContextMenu'
import EditTripModal from '../../../containers/trips/EditTripModal'
import { TripStatuses } from '../../../constants/trip-statuses'
interface IUserTopPanelProps extends RouteComponentProps<any> {
  riderId: string
  getRiderPersonalInfo: (riderId: string) => Promise<IUserTopPanelRider>
  getAppliedPromotions: (riderId: string) => Promise<IAppliedPromotion[]>
  rider: IUserTopPanelRider
  hasValidPromotions: boolean
  vehicle: IVehicle
  currentTrip: IActiveTripResponseV2
}

interface IUserTopPanelState {
  rider: IUserTopPanelRider
  isModalOpen: boolean
  nonFoldingWheelchairActive: boolean
  foldingWheelchairActive: boolean
  nonFoldingIsEditing: boolean
  foldingIsIsEditing: boolean
  messageNotification: boolean
  callNotification: boolean
  showPromotionDetail: boolean
}

class UserTopPanel extends React.Component<IUserTopPanelProps, IUserTopPanelState> {
  constructor(props: any) {
    super(props)
    const notificationPreferences = {
      messageNotification:
        this.props.rider && this.props.rider.notificationPreference === NotificationPreferenceTypes.textMessage,
      callNotification:
        this.props.rider && this.props.rider.notificationPreference === NotificationPreferenceTypes.voice
    }
    this.state = {
      rider: this.props.rider,
      isModalOpen: false,
      nonFoldingWheelchairActive: true,
      foldingWheelchairActive: false,
      nonFoldingIsEditing: false,
      foldingIsIsEditing: false,
      showPromotionDetail: false,
      ...notificationPreferences
    }
  }

  public componentDidMount() {
    this.loadData()
  }

  public async loadData() {
    const riderPersonalInfo = await this.props.getRiderPersonalInfo(this.props.riderId)
    const riderAppliedPromotions = await this.props.getAppliedPromotions(this.props.riderId)

    const mergedRiderInfo = {
      ...riderPersonalInfo,
      appliedPromotions: riderAppliedPromotions
    }

    this.setState({
      rider: mergedRiderInfo
    })
  }

  public render() {
    if (!this.state.rider) {
      return <div>Wait</div>
    }

    const { phone = '', codeCountry } = this.state.rider
    const formattedPhoneNumber = formatPhone(phone, codeCountry)

    const addFundsModal = (props: any) => {
      return <AddFundsModal rider={this.state.rider} {...props} />
    }
    const addCardModal = (props: any) => {
      console.log('add card modal')
      return <AddCardModal rider={this.state.rider} {...props} />
    }
    const balance = this.state.rider.wallet ? this.state.rider.wallet.wallet.balance / 100 : 0
    const internalNote = this.state.rider.internalNote ? this.state.rider.internalNote : ''
    const { currentTrip } = this.props

    const EditDetails = (props: any) => {
      return (
        <EditTripModal
          riderName={this.state.rider.firstName + ' ' + this.state.rider.lastName}
          currentTrip={this.props.currentTrip}
          endMileage={this.props.currentTrip.endMileage}
          {...props}
        />
      )
    }
    const scheduledTrips = [TripStatuses.SCHEDULED, TripStatuses.SCHEDULE_ACCEPTED, TripStatuses.SCHEDULE_REQUESTED]
    const lastStat = currentTrip ? currentTrip.lastStatus : ''
    return (
      <section className='pl1'>
        <Route exact={true} path={`${this.props.match.path}/add-funds`} render={addFundsModal} />
        <Route exact={true} path={`${this.props.match.path}/add-funds/add-card`} render={addCardModal} />
        <Route exact={true} path={`${this.props.match.url}/edit-details`} render={EditDetails} />
        <div className='fit flex flex-column'>
          <div className='flex flex-row'>
            <div className='center'>
              {/* Declare name of Avatar */}
              <ImageView
                entityId={this.state.rider.id}
                isRounded={true}
                width='48px'
                height='48px'
                name={this.state.rider.firstName + ' ' + this.state.rider.lastName}
              />
              <Link className='font-small font-blue' to={`/riders/${this.state.rider.id}/profile/info`}>
                Profile
              </Link>
            </div>
            <div className='flex flex-wrap col-12 ml1 justify-between content-center'>
              <div className='flex flex-column'>
                <div className='h5 col-12 font-dark-grey'>
                  {this.state.rider.firstName} {this.state.rider.lastName}
                </div>
                <div className='h5 col-12 font-grey2'>{formattedPhoneNumber}</div>
                {this.props.hasValidPromotions ? (
                  <div
                    className='col-12 '
                    onMouseEnter={this.setShowPromotionState}
                    onMouseLeave={this.setShowPromotionState}
                  >
                    <CouponIcon className='svg-stroke-green svg-fill-green' />
                  </div>
                ) : null}
                <div className='left-align'>
                  <WalletBalance
                    rider={this.state.rider}
                    riderId={this.state.rider.id}
                    balanceType={BALANCE_TYPES.OVERALL}
                    actionUrl={`${this.props.match.url}/add-funds`}
                  />
                </div>
              </div>
            </div>
          </div>
          {scheduledTrips.includes(lastStat) && <span />}
        </div>
        {this.state.rider.appliedPromotions &&
          this.state.showPromotionDetail &&
          this.state.rider.appliedPromotions.map((appliedPromotion: IAppliedPromotion) => (
            <div>
              <AppliedPromotion className='mr1 mb1 col-11' {...appliedPromotion} />
              <br />
            </div>
          ))}
        {/* Start of grid system */}
        <div className='fit p2 flex'>
          <div className='col-9'>
            {/* //Note */}
            {internalNote ? (
              <div className='fs-14 col-11 font-grey2 red-font'>
                <b>Internal Note: </b>
                {internalNote}
              </div>
            ) : null}
            {!internalNote ? <div className='fs-14 col-11 font-grey2'>{internalNote}</div> : null}
            {/* //Note */}
          </div>
          <div className='col-3' />
        </div>
        {/* End of grid system*/}
      </section>
    )
  }
  private setShowPromotionState = () => {
    this.setState({ showPromotionDetail: !this.state.showPromotionDetail })
  }
}

export default UserTopPanel



// WEBPACK FOOTER //
// ./src/components/trips/rider-info/UserTopPanel.tsx